import React from 'react';
import Button from '../components/UI/Button';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-desc">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button to="/" variant="primary" size="large">
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
